import { styled, TextField } from '@mui/material'

export const CustomerDetailsTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    color: '#000'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: '#000',
    '-webkit-text-fill-color': '#000',
    '& :before': {
      border: '0px'
    }
  },
  '&& .MuiInputBase-root.Mui-disabled:before': {
    border: '0px'
  },
  '&&& .MuiInput-underline': {
    border: 'gray',
    '& .Mui-disabled': {
      border: 'none'
    },
    '&:hover': {
      borderColor: 'gray'
    },
    // '&.Mui-focused:after': {
    //   borderColor: 'gray'
    // },
    '&:before': {
      borderColor: 'gray'
    }
    // '&:after': {
    //   borderBottom: 'initial'
    // }
  }
})
